import { React, useState, useRef, useEffect } from "react";
import AgentLayout from "../components/AgentLayout";
import NavButton from "../components/NavButton";
import axiosInstance from "../../../utils/axiosInstance";
import { useNavigate } from "react-router-dom";
import { isMobile } from "react-device-detect";

const AgentProfile = () => {
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const [showOldPasswordError, setShowOldPasswordError] = useState(false);
  const [oldPasswordErrorMessage, setOldPasswordErrorMessage] = useState("");

  const [showNewPasswordError, setShowNewPasswordError] = useState(false);
  const [newPasswordErrorMessage, setNewPasswordErrorMessage] = useState("");

  const [oldPassword, setOldPassword] = useState("");
  const handleOldPassword = (e) => {
    var password = e.target.value;
    setOldPassword(password);
  };

  const [newPassword, setNewPassword] = useState("");
  const handleNewPassword = (e) => {
    var password = e.target.value;
    setNewPassword(password);
  };

  const handleSubmit = async () => {
    var userObj = {};
    let errorCounter = 0;

    if (oldPassword === "") {
      setShowOldPasswordError(true);
      setOldPasswordErrorMessage("Old Password can not be blank");
      errorCounter++;
    } else {
      setOldPasswordErrorMessage("");
      setShowOldPasswordError(false);
    }

    if (newPassword === "") {
      setShowNewPasswordError(true);
      setNewPasswordErrorMessage("New Password can not be blank");
      errorCounter++;
    } else {
      setNewPasswordErrorMessage("");
      setShowNewPasswordError(false);
    }

    userObj.oldpassword = oldPassword;
    userObj.newpassword = newPassword;

    try {
      const response = await axiosInstance.post(
        "/company/change_password",
        userObj
      );

      if (
        response !== null &&
        response !== undefined &&
        response.data !== null &&
        response.data !== undefined
      ) {
        if (
          response.data.status !== null &&
          response.data.status !== undefined &&
          response.data.status === true
        ) {
          //navigate("/agent/accounts/chart");
          setSuccessMessage(response.data.message);
          setErrorMessage("");
          setNewPassword("");
          setOldPassword("");
        } else {
          setSuccessMessage("");
          setErrorMessage(response.data.message);
        }
      }
    } catch (error) {}
  };
  return (
    <AgentLayout>
      <div class="row" style={{ marginTop: "5px", marginBottom: "1%" }}>
        <div class="col-12 col-md-6">
          <div class="card">
            <div
              class="card-header"
              style={{
                backgroundColor: "#f7f7f7",
                padding: "5px 5px 5px 18px"
              }}
            >
              <strong>Change Password</strong>
            </div>

            <div class="card-body">
              <form action="#" method="post" style={{ padding: "9px" }}>
                <div
                  class="form-group row"
                  style={{
                    display:
                      successMessage != "" || errorMessage != "" ? "" : "none"
                  }}
                >
                  <div
                    class="col-md-12"
                    style={{
                      color: successMessage != "" ? "green" : "red",
                      padding: "10px",
                      fontWeight: "bold"
                    }}
                  >
                    <div
                      style={{ display: successMessage != "" ? "" : "none" }}
                    >
                      {successMessage}
                    </div>
                    <div style={{ display: errorMessage != "" ? "" : "none" }}>
                      {errorMessage}
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label
                    class="col-md-3 col-form-label"
                    for="UserProfile_Stake1"
                  >
                    Old Password
                  </label>

                  <div class="col-md-6">
                    <div>
                      <input
                        class="form-control"
                        onChange={handleOldPassword}
                        autocomplete="off"
                        type="text"
                        name="old_password"
                        id="old_password"
                        value={oldPassword}
                      />
                    </div>
                    <span
                      className="field-validation-error site_family"
                      style={{ display: showOldPasswordError ? "" : "none" }}
                    >
                      {oldPasswordErrorMessage}
                    </span>
                  </div>
                </div>

                <div class="form-group row">
                  <label
                    class="col-md-3 col-form-label"
                    for="UserProfile_Stake1"
                  >
                    NewPassword
                  </label>

                  <div class="col-md-6">
                    <div>
                      <input
                        class="form-control"
                        type="text"
                        name="new"
                        autocomplete="off"
                        id="new"
                        value={newPassword}
                        onChange={handleNewPassword}
                      />
                      <span
                        className="field-validation-error site_family"
                        style={{ display: showNewPasswordError ? "" : "none" }}
                      >
                        {newPasswordErrorMessage}
                      </span>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <div class="form-actions">
                      <button
                        class="btn btn-success"
                        id="changePwdBtn"
                        type="button"
                        name="changePwdBtn"
                        onClick={handleSubmit}
                      >
                        Update
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </AgentLayout>
  );
};
export default AgentProfile;
